"use strict"

import React from "react";
import _ from "underscore";
import { hideDialog, onDialogHidden } from "../../actions/dialog";
import { isNotEmpty } from "../../framework/utils";
import DialogStore from "../../stores/dialog";
import { connect } from "../../utils/aj-react";
import { optional } from "../../utils/lang";
import { Dialog } from "./dialogs";

export default class GlobalDialog extends React.Component {
    constructor(props) {
        super(props);
        connect(this, DialogStore, {});
    }

    _onShown() {
        const options = this.getOptions(),
            documentTitle = document.title,
            locationHref = location.href;

        if (options.onShown && _.isFunction(options.onShown)) {
            options.onShown();
        }
        this.onGoBack = () => {
            const hidden = optional(() => this.state.hidden, true);
            if (!hidden) {
                history.pushState(null, documentTitle, locationHref);
                hideDialog();
            }
        }

        window.addEventListener("popstate", this.onGoBack)
    }

    _onDialogClose(dialogResult) {
        const options = this.getOptions();
        // the order is important here, as calling onDialogHidden wipes away state.options from the store before we have the chance to trigger onClose
        if (options.onClose && _.isFunction(options.onClose)) {
            options.onClose(dialogResult);
        }

        if (isNotEmpty(this.onGoBack)) {
            window.removeEventListener("popstate", this.onGoBack);
        }

        onDialogHidden(true);
    }

    getOptions() {
        return optional(this.state.options, {});
    }

    getContent() {
        const options = this.getOptions();
        return optional(() => options.getContent(), <></>);
    }

    render() {
        const hidden = optional(() => this.state.hidden, true),
            options = this.getOptions(),
            content = this.getContent(),
            dialogProps = _.extend(
                _.omit(options,"content","onClose"),
                {
                    hidden: hidden,
                    onClose: this._onDialogClose.bind(this),
                    onShown: this._onShown.bind(this),
                },
            );

        return(
            <div
                id="global-dialog"
                className="global-dialog"
            >
                <Dialog
                    {...dialogProps}
                >
                    {content}
                </Dialog>
            </div>
        )
    }
}